export enum AdsTooltipErrors {
  INVALID_POSITION = 'Invalid position',
}

/**
 * An interface for the custom `openChange` event for the tooltip
 * @docs
 */
export interface OpenChangeEvent {
  evt?: Event;
  newValue: boolean;
}

export type OpenChangeHandler = (evt: OpenChangeEvent) => void;
